import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-payment',
  templateUrl: './success-payment.component.html',
  styleUrls: ['./success-payment.component.scss']
})
export class SuccessPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
